import styled from 'styled-components'
import { defaultBorderWithRadius } from '../../../lib/styles/Container'
import { MediaElement } from '../../../components/UI/MediaElement'
import { typoHeading6, typoLabel } from '../../../lib/styles/Typography'
import { baseTransition } from '../../../lib/styles/Style'

export const StyledProductTeaserItem = styled.div`
  background-color: ${({ theme }) => theme.colors.black[7]};
  padding: 0.5rem;
  display: flex;
  gap: 1rem;
  border-radius: 0.7rem;
  border: 2px solid transparent;
  align-items: center;
  text-decoration: none;
  color: unset;

  transition-property: all;
  ${baseTransition};

  &:hover {
    ${defaultBorderWithRadius};
    border-width: 2px;
  }
`

export const StyledMediaElement = styled(MediaElement)`
  aspect-ratio: 1/1;
  object-fit: contain;
  height: 4rem;
  width: 4rem;
`

export const StyledNameContainer = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 50%;
  padding-right: 1rem;
  border-right: 1px solid ${({ theme }) => theme.colors.black[5]};
  @media screen and (max-width: 768px) {
    border-right: unset;
    gap: 0.2rem;
  }
`

export const StyledOSContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 50%;
  flex-wrap: wrap;
  gap: 0.75rem;
  @media screen and (max-width: 768px) {
    justify-content: flex-start;
    align-items: flex-start;
  }
`

export const StyledContentContainer = styled.div`
  display: flex;
  flex: 1;
  padding-block: 0.5rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.6rem;
    padding: unset;
  }
`
export const StyledParagraph = styled.span`
  ${typoLabel};
  color: var(--c-base-theme-3);
`

export const StyledProductName = styled.h6`
  ${typoHeading6};
  white-space: nowrap;
  margin: unset;
`
